export enum VariantStyleType {
  VARIANT_DRAWER = 'VARIANT_DRAWER',
}
